<template>
  <div class="user-info">
    <OfficialAccounts />
    <Warning />
    <TaskDownload />
    <span class="v-line"></span>
    <Badge
      v-if="userStore.onlineInfo"
      status="processing"
      :color="userStore.onlineInfo.workState ? '#87d068' : '#f50'"
    />
    <Dropdown>
      <span @click.stop="handleShowSheetCount">
        <Badge
          :number-style="sheetCountStyle"
          :count="serviceStore.getSheetCount"
        >
          <img
            src="https://lerke.oss-cn-shenzhen.aliyuncs.com/AP1552645762440"
          />
        </Badge>

        <span class="user-name">{{ userInfo.userName }}</span>
        <CaretDownOutlined />
      </span>
      <template #overlay>
        <Menu @click="onChange">
          <!-- <MenuItem key="online">
            <span>
              <Badge status="processing" color="#87d068" />
              在线
            </span>
          </MenuItem>
          <MenuItem key="offline">
            <span>
              <Badge status="processing" color="#f50" />
              离线
            </span>
          </MenuItem> -->
          <MenuItem key="stop">
            <span>
              <StopOutlined />
              停止工作
            </span>
          </MenuItem>
          <MenuItem key="logout">
            <span>
              <PoweroffOutlined />
              退出登录
            </span>
          </MenuItem>
        </Menu>
      </template>
    </Dropdown>

    <div @click="toggleDarkMode" class="m-l-12 toggle-theme">
      <i class="iconfont icon-moon text-secondary" v-if="isDark"></i>
      <i class="iconfont icon-sun text-secondary" v-else></i>
    </div>
  </div>
</template>
<script setup lang="ts">
import { createVNode, computed } from 'vue';
import { darkCssIsReady, loadDarkThemeCss } from 'vite-plugin-theme/es/client';
import OfficialAccounts from '../officialAccounts/index.vue';
import TaskDownload from '../taskDownload/index.vue';
import {
  CaretDownOutlined,
  PoweroffOutlined,
  StopOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons-vue';
import { Dropdown, Menu, Modal, Badge, message } from 'ant-design-vue';
import { useRootSetting } from '/@/hooks/setting/useRootSetting';
import { ThemeEnum } from '/@/enums/appEnum';

import { useUserStoreWithOut } from '/@/store/modules/user';
import { useServiceStoreWithOut } from '/@/store/modules/service';
import { stopWorkApi, stopWorkNumApi } from '@/api/service';
import { initOnline } from '/@/core/auth';

import Warning from '../warning/index.vue';

const sheetCountStyle = {
  fontSize: '12px',
  padding: '0 4px',
};

const { getDarkMode, setDarkMode } = useRootSetting();
const { Item: MenuItem } = Menu;

const userStore = useUserStoreWithOut();
const serviceStore = useServiceStoreWithOut();
const userInfo = userStore.getUserInfo;
const isDark = computed(() => getDarkMode.value === ThemeEnum.DARK);
const toggleDarkMode = async () => {
  const darkMode =
    getDarkMode.value === ThemeEnum.DARK ? ThemeEnum.LIGHT : ThemeEnum.DARK;
  setDarkMode(darkMode);

  const htmlRoot = document.getElementById('htmlRoot');
  if (isDark.value) {
    if (import.meta.env.PROD && !darkCssIsReady) {
      await loadDarkThemeCss();
    }
    htmlRoot?.setAttribute('data-theme', 'dark');
  } else {
    htmlRoot?.setAttribute('data-theme', 'light');
  }
};
const onChange = ({ key }) => {
  console.log(key);
  switch (key) {
    case 'logout':
      logout();
      break;
    case 'online':
      handleUserOnline(1);
      break;
    case 'offline':
      handleUserOnline(0);
    case 'stop':
      handleStop();
      break;
  }
};
const handleStop = async () => {
  const { content } = await stopWorkNumApi();

  Modal.confirm({
    title: '停止接单',
    icon: createVNode(ExclamationCircleOutlined),
    cancelText: '取消',
    okText: '确认',
    content: createVNode('div', null, [
      createVNode('span', null, '确定将'),
      createVNode('span', { style: 'color: red;' }, '停止接单，'),
      createVNode('span', null, '当前待处理'),
      createVNode('span', { style: 'color: red;' }, `${content}单，`),
      createVNode('span', null, '请处理完成后再离开'),
    ]),
    onOk() {
      stopWork();
      initOnline();
    },
    onCancel() {},
  });
};
const stopWork = async () => {
  await stopWorkApi();
  message.success('停止接单成功');
};
const logout = () => {
  Modal.confirm({
    title: '温馨提醒',
    icon: createVNode(ExclamationCircleOutlined),
    cancelText: '取消',
    okText: '确认',
    content: '是否确认退出系统',
    onOk() {
      return userStore.logout(false);
    },
    onCancel() {},
  });
};
const handleUserOnline = (workState: number) => {
  const Text = ['离线', '在线'];
  Modal.confirm({
    title: '温馨提醒',
    icon: createVNode(ExclamationCircleOutlined),
    cancelText: '取消',
    okText: '确认',
    content: `是否切换当前状态为${Text[workState]}`,
    onOk() {
      return userStore.updateLine(workState);
    },
    onCancel() {},
  });
};
const handleShowSheetCount = () => {
  console.log('123123', 123123);
};
</script>
<style lang="less" scoped>
.user-info {
  padding: 0 20px;
  display: flex;
  align-items: center;
  position: relative;
  font-size: 16px;
  img {
    width: 28px;
    border-radius: 50%;
  }
  i {
    cursor: pointer;
  }
  .user-name {
    margin: 0 10px;
  }
  .toggle-theme i {
    font-size: 18px;
    &:hover {
      color: #1980ff;
    }
  }
}
.v-line {
  height: 28px;
  width: 1px;
  background-color: rgba(37, 49, 71, 0.15);
  margin: 6px 28px 0 8px;
}
</style>
